import { render } from "./ConfigLojas.vue?vue&type=template&id=3c091dfd&scoped=true&ts=true"
import script from "./ConfigLojas.vue?vue&type=script&lang=ts"
export * from "./ConfigLojas.vue?vue&type=script&lang=ts"

import "./ConfigLojas.vue?vue&type=style&index=0&id=3c091dfd&scoped=true&lang=css"

import exportComponent from "/Users/camp2/Devs/indicar/indicar-gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c091dfd"]])

export default __exports__